import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 50
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };else if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };else if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 font-bold text-2xl md:text-4xl tabular-nums" data-id="element-49">
      <div className="bg-[#1F1A14] px-3 py-2 rounded-lg border border-[#5C4A1F]/60 flex items-baseline shadow-md" data-id="element-50">
        <span className="text-[#8A6E2A]" data-id="element-51">{format(timeLeft.hours)}</span>
        <span className="text-sm md:text-lg ml-1 font-normal text-[#8A6E2A]" data-id="element-52">
          hrs
        </span>
      </div>
      <span className="text-[#5C4A1F]" data-id="element-53">:</span>
      <div className="bg-[#1F1A14] px-3 py-2 rounded-lg border border-[#5C4A1F]/60 flex items-baseline shadow-md" data-id="element-54">
        <span className="text-[#8A6E2A]" data-id="element-55">{format(timeLeft.minutes)}</span>
        <span className="text-sm md:text-lg ml-1 font-normal text-[#8A6E2A]" data-id="element-56">
          min
        </span>
      </div>
      <span className="text-[#5C4A1F]" data-id="element-57">:</span>
      <div className="bg-[#1F1A14] px-3 py-2 rounded-lg border border-[#5C4A1F]/60 flex items-baseline shadow-md" data-id="element-58">
        <span className="text-[#8A6E2A]" data-id="element-59">{format(timeLeft.seconds)}</span>
        <span className="text-sm md:text-lg ml-1 font-normal text-[#8A6E2A]" data-id="element-60">
          sec
        </span>
      </div>
    </div>;
}